<template>
    <div>
        <div class="sm:flex sm:justify-between sm:items-center mb-10 mt-3">
            <div class="mb-4 sm:mb-0">
                <h1 class="text-2xl md:text-3xl text-gray-800 font-bold">
                    My Credit Score
                </h1>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4 py-4">
            <div class="col-span-12">
                <ul class="mb-6 flex flex-row text-xs md:text-sm">
                    <li
                        v-for="(user, index) in users"
                        class="pr-3 text-orange"
                        :class="{ 'text-orange': activeUser.id === user.id }"
                        :key="'user-' + index"
                    >
                        <a
                            :href="'#tab-' + index"
                            @click.prevent="setActiveUser(user)"
                            role="button"
                            class="pill"
                            :class="{ dark: activeUser.id === user.id }"
                        >
                            {{ user.name }}'s Credit Score
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div
            class="bg-white overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg mb-5"
        >
            <creditscore-analytics
                v-if="tabState === 'analytics'"
            ></creditscore-analytics>
            <div class="pt-8 pb-12 px-8" v-if="tabState === 'start'">
                <creditscore-start></creditscore-start>
            </div>

            <div v-if="tabState === 'analytics'">
                <ScoresTable />
            </div>
        </div>

        <credit-score-modal @close="closeCreditScoreModal" />
    </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useCreditScoreStore } from "@/store/creditscore";
import CreditscoreAnalytics from "@/components/creditscore/analytics.vue";
import CreditscoreStart from "@/components/creditscore/start-tracking.vue";
import CreditScoreModal from "@/components/creditscore/modals/credit-score.vue";
import ScoresTable from "@/components/creditscore/scores-table.vue";

export default {
    props: {},
    components: {
        CreditscoreAnalytics,
        CreditscoreStart,
        CreditScoreModal,
        ScoresTable,
    },
    data: () => ({}),
    directives: {},
    computed: {
        ...mapState(useCreditScoreStore, [
            "loadingCreditScoreUsers",
            "loadingUserCreditScore",
            "showCreditScoreModal",
            "users",
            "tabState",
            "activeUser",
            "activeScore",
        ]),
    },
    watch: {
        activeUser() {
            this.getUserScores();
        },
    },
    methods: {
        ...mapActions(useCreditScoreStore, [
            "setUsers",
            "getUserScores",
            "setTabState",
            "setActiveUser",
            "closeCreditScoreModal",
        ]),
    },
    mounted() {
        this.setUsers().then(() => {
            this.setActiveUser(this.users[0]);
        });
    },
};
</script>
